var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-message',{staticClass:"block",attrs:{"active":_vm.errorMessages.length > 0,"title":_vm.title,"type":"is-danger","has-icon":"","icon-size":"is-medium","closable":_vm.closable}},[_c('ul',_vm._l((_vm.errorMessages),function(error){return _c('li',{key:error},[_vm._v(_vm._s(error))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }